import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ScreenTrackingService } from '@angular/fire/analytics';
import { connectFunctionsEmulator, Functions } from '@angular/fire/functions';
import { RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from 'nexus-core';
import { environment } from '../environments/environment';
import { NoInternetService } from './common/no-internet.service';
import { UpdateService } from './common/update.service';

@Component({
    selector: 'nexus-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet, ToastContainerComponent]
})
export class AppComponent {
  constructor(
    readonly noInternetService: NoInternetService,
    readonly updateService: UpdateService,
    readonly screenTrackingService: ScreenTrackingService,
    private readonly functions: Functions,
  ) {

    if(environment.useEmulatedFunctions) {
      connectFunctionsEmulator(this.functions, "127.0.0.1", 5001);
    }
  }
}
